import {
    GET_PROFILE,
    GET_PROFILE_SUCCESS,
    UPDATE_PROFILE,
    UPDATE_PROFILE_SUCCESS,
    UPDATE_PROFILE_FAILURE,
} from './constants';

/**
 *
 * @returns {{type: string}}
 */
const getProfile = () => (
    { type: GET_PROFILE }
);
/**
 *
 * @param profile
 * @returns {{profile: *, type: string}}
 */
const getProfileSuccess = profile => ( {
    type: GET_PROFILE_SUCCESS,
    profile
} );

/**
 *
 * @param formData
 * @param resolve
 * @param reject
 * @returns {{reject: *, resolve: *, formData: *, type: string}}
 */
const updateProfile = (formData, resolve, reject) => ({
    type: UPDATE_PROFILE,
    formData,
    resolve,
    reject,
});

/**
 *
 * @param profile
 * @returns {{type: string, profile: *}}
 */
const updateProfileSuccess = (profile) => ({
    type: UPDATE_PROFILE_SUCCESS,
    profile
});

/**
 *
 * @param errors
 * @returns {{errors: *, type: string}}
 */
const updateProfileFailure = (errors) => ({
    type: UPDATE_PROFILE_FAILURE,
    errors
});

export {
    getProfile,
    getProfileSuccess,
    updateProfile,
    updateProfileSuccess,
    updateProfileFailure
};